export const SET_PRESET = "FILTER/SET_PRESET";
export const SET_FIELD = "FILTER/SET_FIELD";
export const CLEAR_FIELDS = "FILTER/CLEAR_FIELDS";
